var _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOutlookWithGreenTick = function SvgOutlookWithGreenTick(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.025 6.85963V13.1882L22.2366 14.5808C22.2949 14.5978 22.4213 14.599 22.4796 14.5808L31.998 8.1635C31.998 7.40403 31.2895 6.85963 30.8897 6.85963H20.025Z",
    fill: "#0072C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0262 15.5492L22.0446 16.9357C22.3289 17.1447 22.6716 16.9357 22.6716 16.9357C22.3302 17.1447 32.0004 10.7214 32.0004 10.7214V22.3529C32.0004 23.6191 31.1899 24.1501 30.2785 24.1501H20.025L20.0262 15.5492Z",
    fill: "#0072C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57615 12.6315C8.88837 12.6315 8.34034 12.9547 7.93569 13.6C7.53104 14.2452 7.32811 15.0995 7.32811 16.1628C7.32811 17.2418 7.53104 18.0949 7.93569 18.7219C8.34034 19.3501 8.87136 19.6624 9.52755 19.6624C10.2044 19.6624 10.7415 19.3574 11.1376 18.7474C11.5338 18.1374 11.7331 17.2904 11.7331 16.2077C11.7331 15.0788 11.5411 14.2003 11.1559 13.572C10.7707 12.945 10.2445 12.6315 9.57615 12.6315Z",
    fill: "#0072C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.52588e-05 3.64548V28.4044L18.835 32.3536V0L-1.52588e-05 3.64548ZM12.6036 20.2105C11.8077 21.258 10.7699 21.783 9.48916 21.783C8.24119 21.783 7.22532 21.275 6.43911 20.2604C5.65412 19.2445 5.26041 17.9224 5.26041 16.2916C5.26041 14.5698 5.65898 13.1772 6.45734 12.1139C7.2557 11.0507 8.31289 10.5184 9.62891 10.5184C10.872 10.5184 11.8782 11.0264 12.6449 12.0447C13.4129 13.063 13.7969 14.4045 13.7969 16.0705C13.7981 17.7826 13.3995 19.1631 12.6036 20.2105Z",
    fill: "#0072C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6109 26.5216C23.6109 22.9953 26.4154 20.1367 29.875 20.1367C31.6142 20.1367 33.1878 20.8592 34.3228 22.0257L24.7962 30.2599C24.6264 30.0206 24.4725 29.7689 24.336 29.5062C23.8731 28.6155 23.6109 27.5998 23.6109 26.5216Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6805 26.6665C24.6805 23.721 27.0353 21.3332 29.9402 21.3332C32.8451 21.3332 35.2 23.721 35.2 26.6665C35.2 29.6121 32.8451 31.9999 29.9402 31.9999C27.0353 31.9999 24.6805 29.6121 24.6805 26.6665Z",
    fill: "#54AB31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4301 24.8692C32.6168 25.0585 32.6168 25.3655 32.4301 25.5548L29.5611 28.4639C29.3744 28.6533 29.0716 28.6533 28.8849 28.4639L27.4504 27.0094C27.2637 26.82 27.2637 26.513 27.4504 26.3237C27.6371 26.1344 27.9399 26.1344 28.1266 26.3237L29.223 27.4354L31.7538 24.8692C31.9406 24.6798 32.2433 24.6798 32.4301 24.8692Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5195,
    height: 10.6667,
    fill: "white",
    transform: "translate(24.6805 21.3332)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutlookWithGreenTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outlook-with-green-tick.44220e47.svg";
export { ForwardRef as ReactComponent };